import { render, staticRenderFns } from "./Offlinetour.vue?vue&type=template&id=049b0e0f&scoped=true"
import script from "./Offlinetour.vue?vue&type=script&lang=js"
export * from "./Offlinetour.vue?vue&type=script&lang=js"
import style0 from "./Offlinetour.vue?vue&type=style&index=0&id=049b0e0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b0e0f",
  null
  
)

export default component.exports